<template>
	<div class="description-parent" :style="{ 'border-color': borderColor }">
		<div class="description-header" :style="{ 'border-color': borderColor }">
			<h2 class="coco fs-1-5 white">{{ title }}</h2>
			<div v-if="descriptionLogic" class="logo">
				<img :src="`./assets/entities_logos/colored/${data.entity_logo.colored}`" alt="" />
			</div>
		</div>
		<div class="description-content" :class="descriptionLogic ? 'content service' : 'no-content'">
			<template v-if="descriptionLogic">
				<div
					class="sub-header"
					:style="{
						'border-color': borderColor,
						'background-color': data.colors.quarter,
					}"
				>
					<template v-if="currentZoom === 5">
						<span>
							<i class="icon">
								<img src="../../assets/icons/team-icon.png" alt="" />
							</i>
							<h3 class="montserra-b fs-1 white">Créée en {{ data.entity.creation_date }}</h3>
						</span>
						<span>
							<i class="icon">
								<img src="../../assets/icons/home-icon.png" alt="" />
							</i>
							<h3 class="montserra-b fs-1 white">{{ data.entity.number_employees }} salariés</h3>
						</span>
					</template>
					<template v-else-if="currentZoom === 10">
						<h3 class="montserra-b fs-1 white">Les services : {{ getServiceName() }}</h3>
					</template>
				</div>
				<div class="description-container">
					<p class="text montserra-r fs-1 white line-h">
						{{ currentZoom === 5 ? data.entity.description : getServiceDescription() }}
					</p>
				</div>
			</template>
			<template v-else-if="currentZoom === 5">
				<img src="../../assets/icons/no-data.png" />
				<p class="montserra-r white fs-1-5">
					{{ emptyMessage }}
				</p>
			</template>
			<template v-else-if="currentZoom === 10">
				<img src="../../assets/icons/no-data.png" />
				<p class="montserra-r white fs-1-5">
					{{ emptyMessage }}
				</p>
			</template>
		</div>
	</div>
</template>
<style lang="scss" scoped>
	.description-parent {
		background-color: var(--black-bgc);
		width: 100%;
		border: 1px solid var(--white);
		border-radius: var(--border);
		display: flex;
		flex-direction: column;
		.description-header,
		.description-content {
			box-sizing: border-box;
			width: 100%;
			padding: 1rem;
		}

		.description-header {
			box-sizing: border-box;
			border-bottom: 1px solid var(--white);

			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			padding-bottom: 1rem;

			.logo {
				height: 2.5rem;
				img {
					height: 100%;
				}
			}
		}
		.description-content {
			padding-top: 1rem;
			flex-grow: 1;
			display: flex;
			flex-direction: column;
			.sub-header {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;

				box-sizing: border-box;
				padding: 0.5rem;

				background: rgba(256, 256, 256, 0.1); // default background color
				border-radius: var(--border-s);
				border: 1px dashed;
				span {
					display: flex;
					flex-direction: row;
					align-items: center;
					i.icon {
						height: 1.5rem;
						margin-right: 0.5rem;
					}
				}

				margin-bottom: 22px;
			}
			.description-container {
				flex: 1;
				position: relative;
				overflow-y: auto;
				p.text {
					position: absolute;
					top: 0;
					left: 0;
					padding-right: 0.5rem;
				}
			}

			// no content
			&.no-content {
				display: flex;
				justify-content: center;
				align-items: center;
				img {
					width: 4rem;
					margin-bottom: 1.5rem;
				}
				p {
					text-align: center;
				}
			}
		}
	}
</style>
<script>
	import { mapState } from "vuex";
	export default {
		props: {
			info: {
				required: false,
				default: undefined,
			},
		},
		data() {
			return {
				data: undefined,
			};
		},
		computed: {
			...mapState(["content", "currentZoom", "selectedEntity", "selectedService"]), // selectedService.service
			title() {
				if (this.selectedEntity === null && this.currentZoom === 5) return "Séléctionez une entitée";
				if (this.selectedService.service === null && this.currentZoom === 10) return "Séléctionez un service";

				return this.data?.name || "something went wrong";
			},
			emptyMessage() {
				switch (this.currentZoom) {
					case 10:
						return "Vous devez séléctionner un service sur la 3D pour voir ses informations.";
					case 5:
						return " Vous devez séléctionner une entité pour voir ses informations.";
				}
				return "Error, select something";
			},
			borderColor() {
				if (this.descriptionLogic) return this.data?.colors.primary || "#FFF";
				return "#FFF";
			},
			descriptionLogic() {
				if (
					(this.selectedEntity !== null && this.data && this.currentZoom === 5) ||
					(this.selectedService.service !== null && this.data && this.currentZoom === 10)
				)
					return true;
				return false;
			},
		},
		watch: {
			selectedEntity() {
				this.data = { ...this.content.entities[this.selectedEntity] };
			},
			selectedService() {
				if (this.selectedService.entity !== null) {
					this.data = { ...this.selectedService.entity };
				} else {
					this.data = { ...this.content.entities[this.selectedEntity] };
				}
			},
			content() {
				this.data = { ...this.content.entities[this.selectedEntity] };
			},
			info() {
				this.data = { ...this.content.entities[this.selectedEntity] };
			},
		},
		mounted() {
			if (this.selectedEntity !== null) this.data = { ...this.content.entities[this.selectedEntity] };
		},
		methods: {
			getServiceName() {
				return this.selectedService.service?.service_name || this.selectedService.service?.name;
			},
			getServiceDescription() {
				return this.selectedService.service?.description;
			},
		},
	};
</script>
